<script>
import CustomIcon from 'dashboard/components/ui/CustomIcons.vue';

export default {
  name: 'MetadataBadge',
  components: {
    CustomIcon,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    data() {
      const metadata = {
        PURCHASE_INTENTION: {
          label: 'Intenção de Compra',
          textColor: 'text-[#874BE7]',
          bgColor: 'bg-[#F4EDFF]',
          iconColor: '#874BE7',
        },
      };
      return (
        metadata[this.type] || {
          label: 'Desconhecido',
          textColor: 'text-[#000000]',
          bgColor: 'bg-[#F5F5F5]',
          iconColor: '#000000',
        }
      );
    },
  },
};
</script>

<template>
  <div
    :class="`flex items-center gap-2 rounded-lg p-2 text-xs font-semibold ${data.bgColor} ${data.textColor}`"
  >
    <CustomIcon group="metadata" :name="type" :color="data.iconColor" />
    <span class="flex-shrink-0">{{ data.label }}</span>
  </div>
</template>
